module.exports = __webpack_public_path__ + "img/xiaohe4.9d4d6206.png";